import css from 'styled-jsx/css';

const styles = css`@import "./styles/global-variables";

body {
    padding: 0;
    margin: 0;
    overflow-x: hidden;
}

.main-container{
    .footer{
        margin-top:0;
    }

}


    
.content-wrapper {
    background: linear-gradient(180deg, #fff 51%, rgb(225, 19, 131, .2) 180%);
    width: 100%;
    padding-bottom: 130px;

    @media only screen and (min-width: $breakpoint-tb-min) and (max-width: $breakpoint-tb-max) {
        padding: 0 15px;
        margin: 0 auto;
    }

    .whisper-jp-survey-form {
        font-family: "M PLUS Rounded 1c", sans-serif;
        color: #8347ad;
        max-width: 940px;
        margin: auto;
        position: relative;

        @media only screen and (min-width: $breakpoint-tb-min) and (max-width: $breakpoint-tb-max) {
            padding: 0 15px;
            width: 100%;
            margin:50px 0 0 !important;
        }

        @media (max-width: $breakpoint-max){
            margin-top:30px;
        }

        .frm-surveyQuestion {
            .form_head {
                font-size: 48px;
                text-align: left;
                color: #592c82;
                font-weight: 500;

                @media (max-width: $breakpoint-max) {
                    text-align: left;
                    width: 100%;
                    font-size: 26px;
                    padding-top: 20px;
                    margin: 50px 0 0;
                }

                @media only screen and (min-width: $breakpoint-tb-min) and (max-width: $breakpoint-tb-max) {
                    max-width: 100%;
                }
            }

            .ques_checkbtn{
                position: absolute;
                bottom: 7%;
                left: 0;
                right: 0; 

                @media (max-width: $breakpoint-max) {
                    bottom: 7%;
                }
            }

            .survey_Count {
                width: 100%;
                float: left;
                margin-top: 20px;
                margin: 0 auto;

                .survey_sub {
                    opacity: 1;
                }

                span {
                    opacity: .5;
                    float: left;
                    background: url("https://images.ctfassets.net/8g0fievzqg8k/kMNyfl7yrn6Add0KFjaVS/5247d67ca882ff4f7170d52e5cc61207/right-arrow.png") no-repeat 100%;
                    width: 227px;
                    padding-right: 1%;
                    text-align: center;

                    @media only screen and (min-width: $breakpoint-tb-min) and (max-width: $breakpoint-tb-max) {
                        width: 227px;
                        margin: 0 auto;
                    }

                    @media (max-width: $breakpoint-max) {
                        width: 85px;
                        height: auto;
                    }

                    @media (max-width: 320px) {
                        width: 70px;
                        height: auto;
                    }
                }

                .img {
                    height: auto;                   

                    @media only screen and (min-width: $breakpoint-tb-min) and (max-width: $breakpoint-tb-max) {
                        width: 100%;
                        height: auto;
                        margin: 0 auto;
                    }

                    @media (max-width: $breakpoint-max) {
                        float: left;
                        width: 80px;
                        height: auto;
                    }

                    @media (max-width: 320px) {
                        float: left;
                        width: 60px;
                        height: auto;
                    }
                }

                .dull-image{
                    opacity: 0.5;
                }

                span:last-child {
                    background: none;
                    padding: 0;
                }

                @media (max-width: $breakpoint-max) {
                    text-align: center;
                    width: 100%;
                    display: flex;
                }
            }

            .back-to-top{
                display: none !important;
            }

            .sampling_campaign_container {
                float: left;
                width: 100%;
                border: 2px solid #8347ad;
                background: #fff;
                background: -webkit-gradient(linear, left top, left bottom, color-stop(11%, #fff), color-stop(180%, #c1a3d6));
                background: -webkit-linear-gradient(top, #fff 11%, #c1a3d6 180%);
                background: linear-gradient(180deg, #fff 11%, #c1a3d6 180%);
                border-radius: 18px;
                margin: 40px 0 10px;
                padding: 20px 20px 22px;
                box-sizing: border-box;
                text-align: center;
                position: relative;

                @media (max-width: $breakpoint-max) {
                    padding: 0 15px;
                    min-width: 100%;
                }

                 ::before {
                    // content: "";
                    // background: url(https://images.ctfassets.net/8g0fievzqg8k/6xbfP92q1cL5RzRs5jEO7m/a7efa72035feef8d885f1b37d5df25f8/top-ribbon.png) no-repeat;
                    // padding: 130px 130px 70px;
                    // position: absolute;
                    // left: -22px;
                    // top: -38px;
                    // background-size: 80%;
                    content: "";
                    background: url("https://images.ctfassets.net/8g0fievzqg8k/6xbfP92q1cL5RzRs5jEO7m/a7efa72035feef8d885f1b37d5df25f8/top-ribbon.png") no-repeat;
                    padding: 130px 130px 70px;
                    position: absolute;
                    left: -22px;
                    top: -22px;
                    background-size: 80%;

                    @media (max-width: $breakpoint-max) {
                        padding: 50px 60px 30px;
                    }
                }
            }
        }
    }

    .lotterycp-thankyou{
        margin:100px 0 0;

        @media (max-width: $breakpoint-max){
            margin:0 auto;
        }
    }
}`;

export default styles;